
export const pageItems = [
    {key: 'about', name: '소개', link: '/about', target: '_self'}, 
    {key: 'history', name: '히스토리', link: '/history', target: '_self'}, 
    {key: 'story', name: '나눔소식', link: '/story', target: '_self'}, 
    {key: 'event', name: '이벤트', link: '/event_2512', target: '_self'}, 
    {key: 'bonif', name: '본죽', link: 'https://www.bonif.co.kr/brand?brdCd=BF101', target: '_blank'}
    
  ];

export const STORY = [
  {
    postId: 0,
    type: '나눔 소식',
    img: 'upload/story-01.jpg',
    title: '2024년 나눔이 시작되었어요',
    discription: `지난 3월 22일 서울 영등포구에 위치한 독거노인종합지원센터에서 ‘2024 어르신 본죽 왔어요‘ 전달식이 진행되었습니다. 2024년 한 해도 전국 14개 시도 어르신 168명에게 40주간 정기적 본죽 나눔을 실시합니다. 다양한 메뉴의 본죽 6,720그릇이 연간 제공됩니다. ‘어르신 본죽 왔어요’가 정성을 담아 행복을 전합니다. 자세한 이야기를 링크를 통해 만나보세요.`,
    link: 'https://blog.naver.com/bonlove09/223402208636',
  }, {
    postId: 1,
    type: '나눔 소식',
    img: 'upload/story-02.jpg',
    title: '어버이날 맞이 행복토닥 안마봉을 나눠요',
    discription: `본그룹 임직원 120명이 마음을 모아 정성을 다해 봉사에 참여했습니다. 5월 어버이날을 맞아 본죽 나눔을 받으시는 어르신들에게 작은 행복을 전하기 위해 양말목 안마봉을 직접 만들고, 어버이날 안부카드를 정성껏 작성했습니다. 나눔 현장에서 전해온 후기를 링크를 통해 만나보세요.`,
    link: 'https://blog.naver.com/bonlove09/223490898291',
  }, {
    postId: 2,
    type: '나눔 후기',
    img: 'upload/story-03.jpg',
    title: '따뜻한 죽 한 그릇에 담긴 삶의 위로와 희망',
    discription: `띵동, 화요일 11시 30분쯤에 울리는 벨 소리는 매우 반가운 소리이다. “문 열어 놨어요” “어르신 본죽 왔습니다. 오늘은 쇠고기 영양죽입니다” 안부와 정겨운 대화가 오고 간다.
매주 본죽에서 도시락이 배달되면 어떤 맛일까 봄 처녀의 볼을 본 양 설레게 하는 순간이다. 오늘은 아주 오랜만에 엄마 맛 나는 죽을 먹었다. 어릴 적 몸이 아플 때 어머니께서 쑤어 주시던 맛과 비슷했고, 정성이 듬뿍 담긴 느낌에 눈물이 났다. (이어지는 이야기를 링크에서 만나보세요)`,
    link: 'https://blog.naver.com/bonlove09/223631360858',
  },


];



export const MAP = [
  {
    boulId: 0,
    region: 'seoul',
    title: '서울',
    people: 309,
    count: 8130,
    table: [
      { year: 2024, store: ['본죽&비빔밥 고척동양대학점'] },
      { year: 2023, store: ['본죽&비빔밥 목동사거리점'] },
      { year: 2022, store: ['본죽&비빔밥 목동사거리점'] },
      { year: 2021, store: ['본죽 번동점'] },
      { year: 2020, store: ['본죽 삼전동점'] },
      { year: 2019, store: ['본죽 보라매역점', '본죽 신대방삼거리역점'] },
      { year: 2018, store: ['본죽 아현점'] },
      { year: 2017, store: ['본죽 장승배기역점', '본죽 동묘앞역점', '본죽 월곡점'] },
      { year: 2016, store: ['본죽 마천동점', '본죽 숙대입구역점', '본죽 연대대신동점', '본죽 왕십리점'] },
      { year: 2015, store: ['본죽 노원점', '본죽 녹번점', '본죽 수서점', '본죽 연대대신동점', '본죽 연신내점'] },
    ], 
  },   
  {
    boulId: 1,
    region: 'incheon',
    title: '인천',
    people: 101,
    count: 2696,
    table: [
      { year: 2024, store: ['본죽&비빔밥 인천마전동점'] },
      { year: 2023, store: ['본죽&비빔밥 인천마전동점'] },
      { year: 2016, store: ['본죽 인천계양점'] },
      { year: 2015, store: ['본죽 인천간석남부역점', '본죽 인천계양점', '본죽 인천주안점'] },
    ], 
  }, 
  {
    boulId: 2,
    region: 'gyeonggi',
    title: '경기',
    people: 372,
    count: 9920,
    table: [
      { year: 2024, store: ['본죽&비빔밥 광주능평점'] },
      { year: 2023, store: ['본죽 안산월피동점'] },
      { year: 2022, store: ['본죽 부천라일락마을점', '본죽 안산부곡점'] },
      { year: 2020, store: ['본죽 안산원곡점'] },
      { year: 2019, store: ['본죽 구리수택점', '본죽 안양비산동점', '본죽 용인마평점', '본죽&비빔밥 성남중앙병원점', '본죽 구리인창아름마을점'] },
      { year: 2018, store: ['본죽 성남도촌점', '본죽 성남중앙시장점'] },
      { year: 2017, store: ['본죽 안산선부점', '본죽 고잔화승점', '본죽 성남중앙시장점', '본죽 여주오학점'] },
      { year: 2016, store: ['본죽 광명2동점', '본죽 부천팰리스중동시장점', '본죽 분당미금점', '본죽 안산선부점', '본죽 의정부백병원점'] },
      { year: 2015, store: ['본죽 동두천점', '본죽 수원연무점'] },
    ], 
  }, 
  {
    boulId: 3,
    region: 'gangwon',
    title: '강원',
    people: 65,
    count: 2200,
    table: [
      { year: 2024, store: ['본죽&비빔밥 원주점'] },
      { year: 2021, store: ['본죽 홍천점', '본죽&비빔밥 인제점'] },
      { year: 2020, store: ['본죽&비빔밥 삼척점'] },
      { year: 2018, store: ['본죽 강릉포남점'] },
    ], 
  }, 
  {
    boulId: 4,
    region: 'chungbuk',
    title: '충북',
    people: 156,
    count: 3980,
    table: [
      { year: 2024, store: ['본죽&비빔밥 청주금천용담점'] },
      { year: 2023, store: ['본죽 충북음성점'] },
      { year: 2022, store: ['본죽 충북음성점'] },
      { year: 2020, store: ['본죽 증평점'] },
      { year: 2018, store: ['본죽 공단오거리점', '본죽 제천청전점', '본죽 청주용암현대점'] },
      { year: 2017, store: ['본죽 충북영동점'] },
      { year: 2015, store: ['본죽 청주용암LG마트점'] },
    ], 
  }, 
  {
    boulId: 5,
    region: 'chungnam',
    title: '충남',
    people: 104,
    count: 3430,
    table: [
      { year: 2024, store: ['본죽&비빔밥 천안백석푸르지오점'] },
      { year: 2023, store: ['본죽&비빔밥 온양온천역점'] },
      { year: 2022, store: ['본죽&비빔밥 온양온천역점'] },
      { year: 2021, store: ['본죽 공주중동점'] },
      { year: 2020, store: ['본죽 공주중동점'] },
      { year: 2019, store: ['본죽 공주중동점'] },
      { year: 2018, store: ['본죽 충남서천점'] },
      { year: 2016, store: ['본죽 홍성법원점'] },
    ], 
  }, 
  {
    boulId: 6,
    region: 'daejeon',
    title: '대전',
    people: 240,
    count: 6130,
    table: [
      { year: 2024, store: ['본죽&비빔밥 대전월평트레이더스점'] },
      { year: 2023, store: ['본죽 대전판암점'] },
      { year: 2022, store: ['본죽 대전판암점'] },
      { year: 2021, store: ['본죽 대전판암점'] },
      { year: 2020, store: ['본죽&비빔밥 대전송촌점'] },
      { year: 2019, store: ['본죽&비빔밥 대전학하점'] },
      { year: 2018, store: ['본죽 대전관저점', '본죽 대전은행동점', '본죽 대전도마동점', '본죽 대전판암점'] },
      { year: 2017, store: ['본죽 대전월평계룡사옥점'] },
      { year: 2016, store: ['본죽 대전관저점', '본죽 대전노은3지구점'] },
      { year: 2015, store: ['본죽 대전복수점', '본죽 대전용문점'] },
    ], 
  }, 
  {
    boulId: 7,
    region: 'gyeongbuk',
    title: '경북',
    people: 52,
    count: 1240,
    table: [
      { year: 2024, store: ['본죽&비빔밥 경산정평점'] },
      { year: 2018, store: ['본죽 포항상원점'] },
      { year: 2017, store: ['본죽&비빔밥 경북도청점'] },

    ], 
  }, 
  {
    boulId: 8,
    region: 'gyeongnam',
    title: '경남',
    people: 204,
    count: 5860,
    table: [
      { year: 2024, store: ['본죽&비빔밥 김해주촌점'] },
      { year: 2023, store: ['본죽 양산통도사점', '본죽&비빔밥 창녕남지점', '본죽&비빔밥 경남고성점'] },
      { year: 2022, store: ['본죽 양산통도사점', '본죽&비빔밥 경남고성점', '본죽&비빔밥 창녕남지점'] },
      { year: 2021, store: ['본죽&비빔밥 거제고현점'] },
      { year: 2020, store: ['본죽 경남거창점'] },
      { year: 2018, store: ['본죽 남해점'] },
      { year: 2017, store: ['본죽 삼천포점', '본죽 합천점'] },
      { year: 2016, store: ['본죽 마산호계점'] },
    ], 
  }, 
  {
    boulId: 9,
    region: 'daegu',
    title: '대구',
    people: 219,
    count: 6664,
    table: [
      { year: 2024, store: ['본죽&비빔밥 대구법원점'] },
      { year: 2023, store: ['본죽&비빔밥 대구수성교점'] },
      { year: 2022, store: ['본죽 대구팔달시장점', '본죽&비빔밥 대구수성교점'] },
      { year: 2021, store: ['본죽 대구팔달시장점', '본죽&비빔밥 대구동성로중앙점', '본죽&비빔밥 대구북구청점'] },
      { year: 2020, store: ['본죽 대구침산점', '본죽 대구팔달시장점'] },
      { year: 2019, store: ['본죽 대구송라시장점'] },
      { year: 2018, store: ['본죽 대구논공점', '본죽 대구칠곡동아백화점점', '본죽&비빔밥 대구테크노폴리스점'] },
      { year: 2016, store: ['본죽 대구논공점'] },
      { year: 2015, store: ['본죽 대구복현동점'] },
    ], 
  }, 
  {
    boulId: 10,
    region: 'ulsan',
    title: '울산',
    people: 31,
    count: 800,
    table: [
      { year: 2021, store: ['본죽 울산병원점'] },
      { year: 2018, store: ['본죽 울산온양점'] },
    ], 
  }, 
  {
    boulId: 11,
    region: 'busan',
    title: '부산',
    people: 188,
    count: 4924,
    table: [
      { year: 2024, store: ['본죽 부산학장점'] },
      { year: 2023, store: ['본죽 부산학장점'] },
      { year: 2021, store: ['본죽&비빔밥 부산개금점'] },
      { year: 2020, store: ['본죽&비빔밥 부산괴정점'] },
      { year: 2019, store: ['본죽 부산대연점'] },
      { year: 2018, store: ['본죽 부산진역점'] },
      { year: 2017, store: ['본죽 부산광안역점', '본죽 부산숙등역(부민병원)점', '본죽 부산범내골역점'] },
      { year: 2016, store: ['본죽 부산배산역점', '본죽 해운대센텀점'] },
      { year: 2015, store: ['본죽 부산숙등역(부민병원)점'] },
    ], 
  }, 
  {
    boulId: 12,
    region: 'jeonbuk',
    title: '전북',
    people: 75,
    count: 2540,
    table: [
      { year: 2024, store: ['본죽&비빔밥 전주솔내점'] },
      { year: 2023, store: ['본죽&비빔밥 익산중앙점'] },
      { year: 2022, store: ['본죽&비빔밥 익산중앙점', '본죽&비빔밥 전주객사점'] },
      { year: 2021, store: ['본죽 전주평화현대점'] },
      { year: 2017, store: ['본죽 전북진안점', '본죽 남원도통점'] },
    ], 
  }, 
  {
    boulId: 13,
    region: 'jeonnam',
    title: '전남',
    people: 71,
    count: 2540,
    table: [
      { year: 2024, store: ['본죽&비빔밥 여수소호점'] },
      { year: 2023, store: ['본죽&비빔밥 여수죽림점'] },
      { year: 2022, store: ['본죽&비빔밥 여수소호점'] },
      { year: 2021, store: ['본죽 광양마동점'] },
      { year: 2019, store: ['본죽 나주점'] },
      { year: 2017, store: ['본죽 목포하당점'] },
    ], 
  }, 
  {
    boulId: 14,
    region: 'gwangju',
    title: '광주',
    people: 80,
    count: 1890,
    table: [
      { year: 2024, store: ['본죽&비빔밥 광주돌고개역점'] },
      { year: 2023, store: ['본죽&비빔밥 광주소태역점'] },
      { year: 2018, store: ['본죽 광주하남점', '본죽 광주하남산정점'] },
      { year: 2017, store: ['본죽 광주백운고가점'] },
    ], 
  }, 
  {
    boulId: 15,
    region: 'jeju',
    title: '제주',
    people: 13,
    count: 113,
    table: [
      { year: 2021, store: ['본죽 제주일도점', '본죽&비빔밥 제주삼화점'] },
    ], 
  }, 
];